import * as client from './client';
import * as funder from './funder';
import * as project from './project';

export default {
  client,
  funder,
  project,
};
